import { makeStyles } from "@material-ui/core"

import { colors } from "@/styles/colors"
import ColorUtil from "@/utils/ColorUtil"

const useStyles = makeStyles(theme => ({
	attendanceIconButton: {
		minWidth: "auto !important"
	},
	takeAttendanceButton: {
		fontSize: 14,
		minWidth: 197,
		...ColorUtil.getBackgroundAndContrastColor(colors.getPrimaryColor()),
		boxShadow: "0px 2px 2px rgba(0, 0, 0, 0.25)",
		transition: theme.transitions.create("all", {
			easing: theme.transitions.easing.sharp,
			duration: theme.transitions.duration.enteringScreen
		}),
		"&:hover": {
			boxShadow: "0px 2px 2px rgba(0, 0, 0, 0.25)",
			...ColorUtil.getBackgroundAndContrastColor(colors.purple[800])
		}
	},
	finishAttendanceButton: {
		...ColorUtil.getBackgroundAndContrastColor(colors.green[400]),
		minWidth: 210,
		fontSize: 14,
		boxShadow: "0px 2px 2px rgba(0, 0, 0, 0.25)",
		transition: theme.transitions.create("all", {
			easing: theme.transitions.easing.sharp,
			duration: theme.transitions.duration.enteringScreen
		}),
		"&:hover": {
			...ColorUtil.getBackgroundAndContrastColor(colors.green[500]),
			boxShadow: "0px 2px 2px rgba(0, 0, 0, 0.25)"
		},
		"&:disabled": {
			...ColorUtil.getBackgroundAndContrastColor(colors.gray[300]),
			boxShadow: "none"
		}
	},
	inlineTextName: {
		paddingLeft: theme.spacing(0.5)
	}
}))

export default useStyles
